import React, { useEffect, useState } from 'react';
import { SortCondition } from 'shared/enums';
import { dataForOvertimeTable } from 'shared/helpers/utils';
import { usePullSort } from 'shared/hooks';
import { Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import CommonTable from 'features/tables/commonTable';
import { TCommonColumns } from 'shared/types/overtime.types';
import { useLazyGetOvertimeQuery } from 'app/services/edpApiV1/overtime';
import SearchComponent from 'shared/components/search/rvd-overtime';
import { ISearchData } from 'shared/types/rvd.types';
import { useAppSelector } from 'app/store';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import BadgeData from './bageData/BadgeData';

const OvertimeArchive = () => {
  const [search, setSearch] = useState<ISearchData>({});
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const [sortInfo, trigger] = usePullSort();
  const navigate = useNavigate();
  const [getOvertimes, { data: overtimes, isFetching, isLoading }] = useLazyGetOvertimeQuery();
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const setCurrentRvd = (id: number) => {
    navigate(`/overtime/update/${id}`);
  };

  useEffect(() => {
    getOvertimes({
      page: currentPage,
      size: currentSize,
      orderDate: sortInfo.value ? sortInfo.value : undefined,
      type: 'myArchive',
      allAvailableOrganizations,
    });
  }, [getOvertimes, currentPage, currentSize, sortInfo.value, allAvailableOrganizations]);

  useEffect(() => {
    const newData = {};
    Object.keys(search).forEach(key => {
      if (search[key]) {
        newData[key] = search[key];
      }
    });
    getOvertimes({ page: currentPage, size: currentSize, ...newData, type: 'myArchive', allAvailableOrganizations });
  }, [currentPage, currentSize, getOvertimes, search, allAvailableOrganizations]);

  const onSearch = (data: ISearchData) => {
    setSearch({ ...data });
  };

  const columns: TCommonColumns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Дата',
      dataIndex: 'created',
      key: 'created',
      sortDirections: [SortCondition.ASCEND, SortCondition.DESCEND],
      sorter: true,
      onHeaderCell: _ => ({
        onClick: () => trigger(),
      }),
    },
    {
      title: 'Количество сотрудников',
      dataIndex: 'count',
      key: 'count',
    },
    {
      title: 'Статус',
      dataIndex: 'id',
      key: 'id',
      render: id => <BadgeData overtime={overtimes?.data.find(elem => id == elem.id)}></BadgeData>,
    },
    {
      title: 'Комментарий',
      dataIndex: 'userComment',
      key: 'userComment',
      render: (userComment: string) => {
        return (
          <div title={userComment} className="rvd-user-comment">
            {userComment}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <SearchComponent onSearch={onSearch} />
      <Spin spinning={isLoading && isFetching}>
        <CommonTable
          dataSource={dataForOvertimeTable(overtimes?.data || [])}
          columns={columns}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          total={overtimes?.pagination.total}
          setCurrentSize={setCurrentSize}
          currentSize={currentSize}
          onclickToRow={setCurrentRvd}
        />
      </Spin>
    </>
  );
};

export default OvertimeArchive;
